module.exports = __webpack_public_path__ + "static/ogp-about-a490028f9f4bf5dcbf78b7c53abe909c.png";